module.exports = {
    "wy": "Enhancer Forum",
    "admin": "Admin",
    "plate.admin": "Moderator",
    "bye": "Good Bye in global",
    "common.confirm": "Confirm",
    "common.cancel": "Cancel",
    "common.reply": "Reply",
    "common.tip": "Tip",
    "common.no.data": "No Data",
    "common.markdown": "Markdown",
    "common.preview": "Preview",
    "common.upload": "Image",
    "common.edit": "edit",
    "common.remove": "remove",
    "just.now": "just now",
    "minute.ago": "minutes ago",
    "hour.ago": "hour(s) ago",
    "day.ago": "day(s) ago",
    "month.ago": "month(s) ago",
    "year.ago": "year(s) ago",
    "essence": "essence",
    "top": "top",
    "untop": "untop",
    "experience": "experience",
    "widget": "Widget-Dev",
    "question": "question",
    "bug": "Bug",
    "other": "other",
    "star": "collect",
    "unstar": "uncollect",
    "unessence": "unessence",
    "lock": "lock",
    "unlock": "unlock",
    "praise": "up",
    "unpraise": "down",
    "collect.topic": "Collected Topic",
    "topic.type": "please select topic type",
    "tip.title.name.length": "the length of title should be {{min}}-100{{max}}",
    "tip.content.length": "the length of content should be {{min}}-100{{max}}",
    "fileSize": "The file size should be less than 1M",
    "uploadFail": "Failed to upload image, make sure the file size should be less than 1M ",
    "resolved": "[Resolved]",
    "fixed": "[Fixed]",
    "file.size": "The file size should be less than {{size}} M",
    "img.tip": "please paste after screenshot, don't copy image",
    "answer.topic": "Answered Topic",
    "answered.topic": "Answered Topic",
    "notice": "Notice",
    "requirement": "Requirement"
}


// WEBPACK FOOTER //
// ./src/i18n/locale.en.js